import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-timeline-workshop-absence',
    templateUrl: './timeline-workshop-absence.component.html',
    styleUrls: ['./timeline-workshop-absence.component.scss'],
    standalone: false
})
export class TimelineWorkshopAbsenceComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
